//include 4 
jQuery(function(){
    var privateFunctions = {
        geocode: function () {
            return $.Deferred(function (defer) {
                navigator.geolocation.getCurrentPosition(function(position) {

                    var reverseGeocode = function(lat, lon, lang) {
                        lang = lang || "de";
                        var url = "https://geocoder.pixelmap.at/reverse?lat=" + lat + "&lon=" + lon + "&lang=" + lang;

                        // Bearer Token (not sure if it’s needed)
                        var bearerToken = "8912e7771f167257c8a4a01ebac3ce13";

                        return new Promise(function(resolve, reject) {
                            fetch(url, {
                                method: "GET",
                                headers: {
                                    "Authorization": "Bearer " + bearerToken,
                                    "Content-Type": "application/json"
                                }
                            })
                            .then(function(response) {
                                if (!response.ok) {
                                    throw new Error("HTTP error! Status: " + response.status);
                                }
                                return response.json();
                            })
                            .then(function(data) {
                                if (data.features && data.features.length > 0) {
                                    resolve(data.features[0].properties);
                                } else {
                                    reject("No location data found");
                                }
                            })
                            .catch(function(error) {
                                console.error("Error fetching reverse geocode data:", error);
                                reject(error);
                            });
                        });
                    };

                    reverseGeocode(position.coords.latitude, position.coords.longitude)
                        .then(function(locality) {
                            if (locality && locality.city) {
                                var place = locality.city;
                                var apiUrl = window.pixelpoint.domainService.get('apiEndpoint');

                                $.ajax({
                                    url: apiUrl + "location/suggest?q=" + place,
                                    method: "GET"
                                })
                                .done(function(data) {
                                    defer.resolve(data);
                                })
                                .fail(defer.reject)
                                .always(defer.always);
                            }
                        })
                        .catch(function(error) {
                            console.error("Error processing location:", error);
                        });

                }, function(error) {
                    defer.reject();
                    console.log("Leider konnte Ihre Position nicht ermittelt werden. Bitte überprüfen Sie Ihre Sicherheitseinstellungen und versuchen Sie es erneut.", "Fehler beim Ermitteln Ihrer Position!");
                });
            });
        }
    };

    window.pixelpoint.geoTool = {
        geocode: privateFunctions.geocode
    };
});
